module.exports = __webpack_public_path__ + "static/media/thumbnail.3b87f1d8.jpg";